var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormCertificatePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_63_6806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1333 17.4667H11.6C11.6 17.6687 11.7141 17.8533 11.8948 17.9437C12.0755 18.034 12.2917 18.0145 12.4533 17.8933L12.1333 17.4667ZM14.2667 15.8667L14.5867 15.44C14.397 15.2978 14.1363 15.2978 13.9467 15.44L14.2667 15.8667ZM16.4 17.4667L16.08 17.8933C16.2416 18.0145 16.4578 18.034 16.6385 17.9437C16.8192 17.8533 16.9333 17.6687 16.9333 17.4667H16.4ZM14.2667 13.7333C12.7939 13.7333 11.6 12.5394 11.6 11.0667H10.5333C10.5333 13.1285 12.2048 14.8 14.2667 14.8V13.7333ZM16.9333 11.0667C16.9333 12.5394 15.7394 13.7333 14.2667 13.7333V14.8C16.3285 14.8 18 13.1285 18 11.0667H16.9333ZM14.2667 8.4C15.7394 8.4 16.9333 9.59391 16.9333 11.0667H18C18 9.0048 16.3285 7.33333 14.2667 7.33333V8.4ZM14.2667 7.33333C12.2048 7.33333 10.5333 9.0048 10.5333 11.0667H11.6C11.6 9.59391 12.7939 8.4 14.2667 8.4V7.33333ZM11.6 13.2V17.4667H12.6667V13.2H11.6ZM12.4533 17.8933L14.5867 16.2933L13.9467 15.44L11.8133 17.04L12.4533 17.8933ZM13.9467 16.2933L16.08 17.8933L16.72 17.04L14.5867 15.44L13.9467 16.2933ZM16.9333 17.4667V13.2H15.8667V17.4667H16.9333ZM18 7.33333V3.6H16.9333V7.33333H18ZM16.4 2H3.6V3.06667H16.4V2ZM2 3.6V16.4H3.06667V3.6H2ZM3.6 18H10.5333V16.9333H3.6V18ZM2 16.4C2 17.2836 2.71634 18 3.6 18V16.9333C3.30545 16.9333 3.06667 16.6945 3.06667 16.4H2ZM3.6 2C2.71635 2 2 2.71634 2 3.6H3.06667C3.06667 3.30545 3.30545 3.06667 3.6 3.06667V2ZM18 3.6C18 2.71634 17.2836 2 16.4 2V3.06667C16.6945 3.06667 16.9333 3.30545 16.9333 3.6H18ZM5.2 7.33333H10.5333V6.26667H5.2V7.33333ZM5.2 10.5333H8.4V9.46667H5.2V10.5333Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_63_6806"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormCertificatePlaceholder);
export default __webpack_public_path__ + "static/media/form-certificate-placeholder.a66570fe1022dd1b86a0d1812546ab27.svg";
export { ForwardRef as ReactComponent };